import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

// FIXME: complete the implementation (it seems very wrong)
/**
 * TODO:
 */
export const referenceEntity = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.plugins.selectionPlugin.applied.selectors.selectionLookup.asObservable.pipe(
      rxjs.map(selectionLookup => {
        if (!selectionLookup) {
          return store.effects.SKIP
        }
        // TODO: how to get id from the 'storage' actions?
        // TODO: why is this indexing 0?
        const [selectionTarget, [id] = []] =
          Object.entries(selectionLookup)[0] ?? []

        if (id !== undefined && selectionTarget !== undefined) {
          return plugin.feature.actions.referenceEntity
            .from('referenceEntity (effect)')
            .create({
              id,
              referencerSelectionTarget: selectionTarget,
            })
        }
        // FIXME: what do to here?
        return store.effects.SKIP
      }),
    ),
)
